import { useState } from "react";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { Wordmark } from "@/components/Wordmark";
import { Sidebar } from "@/features/dashboard/components/Sidebar";
import { ROUTES } from "@/constants/routes";

export function MobileHeader() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-30 flex items-center justify-between border-b border-border bg-background/95 px-5 py-4 backdrop-blur lg:hidden">
      <Wordmark to={ROUTES.dashboard} />
      <button type="button" onClick={() => setOpen(true)} data-testid="mobile-menu-button" aria-label="Open menu" className="rounded-md border border-border p-2 transition-colors hover:bg-muted">
        <Menu className="h-5 w-5" />
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" data-testid="mobile-nav-drawer" className="w-[280px] border-r-0 bg-ink p-0 text-zinc-100 [&>button]:text-zinc-300">
          <SheetTitle className="sr-only">Navigation</SheetTitle>
          <SheetDescription className="sr-only">Dashboard sections</SheetDescription>
          <Sidebar idPrefix="mobile-" onNavigate={() => setOpen(false)} />
        </SheetContent>
      </Sheet>
    </header>
  );
}
